module.exports = __webpack_public_path__ + "media/images/countrysquared/tv-6c59a036ba236ed0abcb4133ae858ff1.svg";